module.exports = {"id":"142258","name":"Sammy Bossut","rating":"72","photo":"./data/images/photos/0/142258.png","club":{"name":"Zulte-Waregem","logo":"./data/images/clubs/Zulte-Waregem.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SammyBossut0.json
// module id = 3800
// module chunks = 0